import React from 'react'

export const ReccurringPosting = () => {
  return (
    <div>ReccurringPosting</div>
  )
}
